import { createContext, useContext } from 'react';

// The type for the contact methods
export type ContactMethods = {
    preferableMethod?: string | undefined;
    phone?: {phoneNumber: string | undefined} | undefined;
    telegram?: {userName?: string | undefined, phoneNumber?: string | undefined} | undefined;
    viber?: {phoneNumber: string | undefined} | undefined;
    whatsapp?: {phoneNumber: string | undefined} | undefined;
  } | undefined;

// The type for the user data
export type UserDataType = {
  lang: string | null | undefined;                      // e.g., "ru"
  user_id?: string | null | undefined;
  telegram_user_id?: string | null | undefined;
  price_level?: number | string | null | undefined;
  channel: string | null | undefined;                   // e.g., "web"
  channel_name?: string | null | undefined;             // usually a telegram bot name e.g., "iFoodMeBot"
  channel_first_name?: string | null | undefined;       // user's first name e.g. at telegram   
  channel_last_name?: string | null | undefined;        // user's last name e.g. at telegram   
  channel_user_name?: string | null | undefined;        // uniqueid username at the channel, e.g. at telegram
  orders: number[];
  update_time: number;                                  // Timestamp in milliseconds
  loc_latitude: number | null | undefined;
  loc_longitude: number | null | undefined;
  location: string | undefined;                         // e.g., "Montenegro_Bar"
  countryCode: string;                                  // e.g., "+382"
  phone: string;                                        // e.g., "69760287"
  contacts?: ContactMethods
};

// The context may be null before data is loaded

const UserDataContext = createContext<UserDataType | null>(null);

export const useUserData = () => useContext(UserDataContext);

export default UserDataContext;
